import React, { useState } from 'react';
import Navbar from '../components/navbar/navbar';
import Footer from '../components/footer/footer';
import './Careers.css';
import SEO from '../components/SEO';

const JOBS = [
  { id: 1, title: "Senior Mobile Engineer (Flutter & Dart)", dept: "Engineering", type: "Full-time / Remote", desc: "Lead the development of our cross-platform rider and driver apps, optimizing real-time tracking, offline synchronization, and state management." },
  { id: 2, title: "Firebase & Cloud Backend Engineer", dept: "Engineering", type: "Full-time / Remote", desc: "Build scalable real-time matching dispatchers, secure subscription billing pipelines, and custom Firebase Cloud Functions." },
  { id: 3, title: "Mobile UI Engineer (Flutter & Dart)", dept: "Engineering", type: "Full-time / Remote", desc: "Implement high-fidelity, interactive animations, custom maps marker layers, and fluid transitions across mobile views." },
  { id: 4, title: "Growth & Operations Coordinator", dept: "Operations", type: "Full-time / Hybrid", desc: "Coordinate on-boarding, subscription verification, and localized marketing to scale the driver community in new cities." }
];

function Careers() {
  const [selectedDept, setSelectedDept] = useState('All');
  
  const depts = ['All', 'Engineering', 'Operations'];
  const filteredJobs = selectedDept === 'All' ? JOBS : JOBS.filter(job => job.dept === selectedDept);

  return (
    <div className="careers-page-wrapper">
      <SEO 
        title="Careers - Join Our Team"
        description="Explore open engineering, operations, and support roles at 9tro Ride. Help us build fair transit and logistics tools."
        url="https://www.9troride.com/careers"
      />
      <Navbar showSubNavbar={false} />

      <section className="careers-hero">
        <div className="careers-hero-container">
          <span className="hero-tag">Join the Crew</span>
          <h1>Build the future of fair commerce and transit</h1>
          <p>Join a fast-growing, mission-driven team working on standard subscription matching tools for drivers, chefs, and couriers.</p>
        </div>
      </section>

      <section className="jobs-section">
        <div className="jobs-container">
          <div className="jobs-filter-row">
            {depts.map(dept => (
              <button 
                key={dept} 
                className={`filter-btn ${selectedDept === dept ? 'active' : ''}`}
                onClick={() => setSelectedDept(dept)}
              >
                {dept}
              </button>
            ))}
          </div>

          <div className="jobs-grid">
            {filteredJobs.length === 0 ? (
              <div className="no-jobs">
                <p>No open positions in this department at this time.</p>
              </div>
            ) : (
              filteredJobs.map(job => (
                <div key={job.id} className="job-card">
                  <div className="job-meta">
                    <span className="job-dept-badge">{job.dept}</span>
                    <span className="job-type">{job.type}</span>
                  </div>
                  <h3>{job.title}</h3>
                  <p>{job.desc}</p>
                  <a href="mailto:careers@9troride.com" className="apply-link-btn">Apply Now →</a>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      <section className="careers-cta">
        <div className="careers-cta-container">
          <h2>Don't see your role listed?</h2>
          <p>We are always looking for passionate builders, designers, and logistics leaders. Pitch your own role to us.</p>
          <a href="mailto:careers@9troride.com" className="cta-email-btn">careers@9troride.com</a>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Careers;
